
import { el } from 'element-plus/es/locale'
import { defineComponent, reactive, toRefs,getCurrentInstance, nextTick, onMounted } from 'vue'
import {useRoute,useRouter} from 'vue-router'
export default defineComponent({
    props:{
        currentPath:{
            type:Array,
            default:[]
        }
    },
    setup(prop,context) {
        const {proxy,appContext}= getCurrentInstance() as any
        const axios =appContext.config.globalProperties.axios
        const router=useRouter()
        const route=useRoute()
        const state:any=reactive({
            platformJson:appContext.config.globalProperties.platformJson,
            searchListHeight:window.innerHeight*0.6,
            treeFilter:'',
            navShow:false,
            searchShow:false,
            showPopover:false,
            currentNode:'',//当前节点
            inputValue:'',//输入框的值
            treeData:[],
            treeJsonData:[],
            lineTreeData:[],
            defaultProps:{
                children: 'children',
                label: 'name',
            },
            searchList:[],
            searchTotal:0
        })
        const methods=reactive({
            handleClickLogo:()=>{
                router.push('/mhome')
            },
            openYjStudy:()=>{
                window.open('https://appo0gfiyw12825.h5.xiaoeknow.com','_blank')
            },
            openWeb:()=>{
                window.open('https://www.yijingcloud.com/','_blank')
            },
            toHome:()=>{
                router.push('/mhome')
            },
            handlePathItem:(data:any)=>{
                state.currentNode=data.id
                context.emit('getArticleMes',data)
                router.push(`/marticle/${data.id}?bookId=${route.query.bookId}`)
            },
            handleNodeClick:(data:any)=>{
                state.currentNode=data.id
                state.navShow=false
                context.emit('getArticleMes',data)
                router.push(`/marticle/${data.id}?bookId=${route.query.bookId}`)
            },
            inputClick:()=>{
               state.showPopover =true
            },
            closeSearch:()=>{
                state.searchShow=false
            },
            changeSearch:(val:any)=>{
                state.showPopover =true
                console.log(val,'val')
                if(val==''){
                    state.searchList=[]
                }else{
                    axios.get('/open/search',{
                       key:state.inputValue
                    }).then((res:any)=>{
                        if(res.data.code==200){
                            console.log(res.data.data)
                            state.searchList=res.data.data.list
                            state.searchTotal=res.data.data.total
                        }

                    })
                }
            },
            // 选中过滤的值，开始进入文章页面
            handleSelect:(val:any)=>{
                state.showPopover =false
                state.searchShow=false
                // 进入文章页
                let data=val.current
                if(data.bookId==route.query.bookId){
                    context.emit('getArticleMes',data)
                    state.currentNode=data.id
                    router.push(`/marticle/${data.id}?bookId=${route.query.bookId}`)
                }else{
                    router.push(`/marticle/${data.id}?bookId=${data.bookId}`)
                    context.emit('refreshArticle')
                }
                
            },
            openPopUp:()=>{
                axios.get(`/open/tree/${route.query.bookId}`,{}).then((res:any)=>{
                    let data:any=res.data
                    if(data.code==200){
                        state.treeData=data.data.list
                        state.treeJsonData=JSON.parse(JSON.stringify(data.data))
                        state.lineTreeData=[]
                        methods.getLineTree(data.data.list)
                        // console.log(state.lineTreeData,1111)
                        nextTick(()=>{
                            proxy.$refs.treeRef.setCurrentKey(state.currentNode)
                        })
                        // 看看有没有路由传过来的id，有就展示，没有就取树列第一个
                    }
                })
            },
            getLineTree:(list:any)=>{
                list.forEach((el:any) => {
                    state.lineTreeData.push({
                        id:el.id,
                        name:el.name,
                        pid:el.pid
                    })
                    if(el.children instanceof Array&&el.children.length>0){
                        methods.getLineTree(el.children)
                        // console.log(el.children,'children',state.treeData)
                    }
                });
            },
            inputChangValue:(val:any)=>{
                if(val){
                    let list:any=[]
                    state.lineTreeData.find((item:any)=>{
                        if(item.name.indexOf(val)>=0){
                            list.push(item)
                        }
                    })
                    state.treeData=list
                }else{
                    state.treeData=state.treeJsonData
                }
            },
            navClick:()=>{
                state.navShow=true
                state.treeFilter=''
            },
            openAwsSix:()=>{
                window.location.href='https://docs.awspaas.com/help/index.html'
            }
        })
        onMounted(()=>{})
        return {
            ...toRefs(state),
            ...toRefs(methods)
        }
    },
})
